<template>
    <div class="donation-amount-picker">
        <h3 class="section-title mb-4">{{ title }}</h3>

        <!-- Preset Amount Buttons -->
        <v-row class="preset-amounts mb-4">
            <v-col
                v-for="preset in presetAmounts"
                :key="'preset-' + preset"
                cols="6"
                sm="3"
                class="pa-2"
            >
                <v-btn
                    :color="selectedAmount === preset ? 'primary' : 'primary'"
                    :outlined="selectedAmount !== preset"
                    depressed
                    block
                    height="50"
                    @click="selectAmount(preset)"
                    :disabled="disabled"
                    class="preset-btn"
                >
                    ${{ preset }}
                </v-btn>
            </v-col>
        </v-row>

        <!-- Custom Amount Input -->
        <v-row class="custom-amount mb-4">
            <v-col cols="12">
                <v-text-field
                    v-model="customAmount"
                    outlined
                    :label="customLabel"
                    type="number"
                    min="10"
                    prefix="$"
                    :hint="customAmount && parseFloat(customAmount) < 10 ? 'Minimum donation is $10' : ''"
                    persistent-hint
                    :error="customAmount && parseFloat(customAmount) > 0 && parseFloat(customAmount) < 10"
                    :disabled="disabled"
                    @input="onCustomAmountInput"
                    @focus="clearPresetSelection"
                ></v-text-field>
            </v-col>
        </v-row>

        <!-- Action Button -->
        <v-row>
            <v-col cols="12">
                <v-btn
                    color="primary"
                    depressed
                    block
                    x-large
                    :loading="loading"
                    :disabled="!canSubmit"
                    @click="submit"
                    class="action-btn"
                >
                    {{ buttonText }} ${{ displayAmount }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'DonationAmountPicker',
    props: {
        title: {
            type: String,
            default: 'Select donation amount'
        },
        buttonText: {
            type: String,
            default: 'Donate'
        },
        customLabel: {
            type: String,
            default: 'Custom Amount'
        },
        presetAmounts: {
            type: Array,
            default: () => [10, 25, 50, 100]
        },
        defaultAmount: {
            type: Number,
            default: 25
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedAmount: this.defaultAmount,
            customAmount: null
        }
    },
    computed: {
        donationAmount() {
            if (this.customAmount && parseFloat(this.customAmount) > 0) {
                return parseFloat(this.customAmount)
            }
            return this.selectedAmount || 0
        },
        displayAmount() {
            return this.donationAmount.toFixed(2)
        },
        canSubmit() {
            return !this.disabled && this.donationAmount >= 10
        }
    },
    methods: {
        selectAmount(amount) {
            this.selectedAmount = amount
            this.customAmount = null
        },
        onCustomAmountInput() {
            if (this.customAmount && parseFloat(this.customAmount) > 0) {
                this.selectedAmount = null
            }
        },
        clearPresetSelection() {
            this.selectedAmount = null
        },
        submit() {
            if (this.canSubmit) {
                this.$emit('submit', this.donationAmount)
            }
        },
        reset() {
            this.selectedAmount = this.defaultAmount
            this.customAmount = null
        }
    }
}
</script>

<style scoped>
.section-title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
}

.action-btn {
    font-size: 18px !important;
    font-weight: 600;
    height: 56px !important;
}

.action-btn.v-btn .v-btn__content {
    color: #fff !important;
}

.preset-amounts .v-btn {
    font-size: 16px !important;
    font-weight: 600;
}

.preset-amounts .v-btn--outlined {
    border: 2px solid #1976d2 !important;
}
</style>
